import { IANAZone, Settings } from 'luxon';
import { logger } from '@amzn/atoz-shiftapp-metrics';

export const setAssociateLocaleAndTimeZone = (
    locale: string,
    timeZone: string
): void => {
    try {
        Settings.defaultLocale = locale;

        if (IANAZone.isValidZone(timeZone)) {
            Settings.defaultZone = timeZone;
        } else {
            logger.emitWarn('User designated timezone is invalid', {
                context: { timeZone }
            });
        }
    } catch (error) {
        logger.emitWarn('Failed to set language/timeZone for AA', {
            error: error as Error
        });
    }
};
